import React from "react";
import "./StayButton.css";

const StayButton = ({ onClick }) => {
  return (
    <button
      className="StayButton"
      onClick={onClick}
    >
      Pozostań
    </button>
  );
};

export default StayButton;
